module.exports = __webpack_public_path__ + "static/media/image_10.c35ee3ff.png";